






























































import { Component, Prop, Vue } from 'vue-property-decorator'
import Moment from 'moment'

@Component

export default class ComponentDashboardRecebimentoFuturo extends Vue {
  @Prop({ default: [] }) recebimento
  @Prop({ default: false }) isReport
  @Prop({ default: true }) showValues

  goToReportMesPage(mes) {
    const date = Moment(mes).format('YYYY-MM')
    const url = `/relatorio-detalhe/mes/${date}`

    // @ts-ignore
    if (this.isReport) this.$router.push(url)

    this.$ga.event('recebimento', 'divergencia-mes-detalhe', this.$user.profile.email)
  }

  isAheadPayment(date) {
    const currentDate = Moment(new Date())
    const paymentDate = Moment(date.mesReferencia)

    const isAheadPayment = paymentDate > currentDate

    return isAheadPayment
  }

  isCurrentDate(date) {
    const currentDate = Moment(new Date()).format('MM/YYYY')
    const paymentDate = Moment(date).format('MM/YYYY')

    const isCurrentDate = currentDate === paymentDate

    return isCurrentDate
  }

  isNegativeValue(value) {
    const isNegativeValue = value < 0

    return isNegativeValue
  }

  isPositiveValue(value) {
    const isPositiveValue = value > 0

    return isPositiveValue
  }
}
